import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueAMap from "vue-amap";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "vue-area-linkage/dist/index.css"; // v2 or higher
import VueAreaLinkage from "vue-area-linkage";
import VCalendar from "v-calendar";
import ECharts from "vue-echarts";
import { use } from "echarts/core";
import directive from "./directive"; // directive
import "@/assets/icons"; // svg icon
import { initRsaPublicKey } from "@/services/base.js";

import Pagination from "./components/Pagination";
import "@/utils/date";
import {
  parseTime,
  resetForm,
  addDateRange,
  addBeginAndEndTime,
  handleTree,
  getClientWidth,
  downloadAndModifyName,
} from "@/utils/ruoyi";
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.addBeginAndEndTime = addBeginAndEndTime;
Vue.prototype.handleTree = handleTree;
Vue.prototype.clientWidth = getClientWidth;
Vue.prototype.downloadAndModifyName = downloadAndModifyName;

import Distpicker from "v-distpicker";
Vue.component("v-distpicker", Distpicker);
// import ECharts modules manually to reduce bundle size
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart, PieChart, GaugeChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  LegendComponent,
  MarkPointComponent,
  ToolboxComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  GaugeChart,
  GridComponent,
  TooltipComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  LegendComponent,
  MarkPointComponent,
  ToolboxComponent,
]);
Vue.component("v-chart", ECharts);
Vue.component("Pagination", Pagination);

import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

Vue.use(VueVirtualScroller);

Vue.config.productionTip = false;
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "427f235fe396893783a3b115372febc1",
  plugin: [
    "AMap.Autocomplete",
    "AMap.Geocoder",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.AMapManager",
    "AMap.Geolocation",
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.4",
});
Vue.use(ElementUI);
Vue.use(VueAreaLinkage);
Vue.use(directive);
Vue.use(VCalendar, {
  componentPrefix: "vc",
});

async function bootstrap() {
  await initRsaPublicKey();

  new Vue({
    render: (h) => h(App),
    router,
    store,
  }).$mount("#app");
}
bootstrap();
